import { createContext, useEffect, useState } from "react";
import instance from "../../../../axios/instance";
import Spinner from "../../../../components/spinners/Spinner";


const UserContext = createContext()

function UserProvider({ children }) {

    const [user, setUser] = useState()
    const token = window.sessionStorage.getItem("ACCESS_TOKEN")

    const [userLoader, setUserLoader] = useState(false)




    async function getCurrentUser() {
        setUserLoader(true)
        instance.get("/doctor", {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(response => {
            //console.log(response.data);
            setUser(response.data)
            setUserLoader(false)
        })
        .catch(error => {
            console.log("An error occured while getting user, refresh page");
            setUserLoader(false)
        })
    }

    useEffect(() => {
        getCurrentUser()
    }, [])



    return (
        <UserContext.Provider value={{ user, setUser }}>
            {userLoader ? <Spinner /> : children}
        </UserContext.Provider>
    )
}

export { UserContext, UserProvider }